var React = require('react');

function ArrowRebrandInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.1348 5.43459C12.7843 5.08401 12.2158 5.08401 11.8653 5.43459C11.5149 5.78495 11.5147 6.35292 11.8647 6.70359L16.253 11.0998H6.20005C5.70299 11.0998 5.30005 11.5027 5.30005 11.9998C5.30005 12.4969 5.70299 12.8998 6.20005 12.8998H16.253L11.8647 17.296C11.5147 17.6467 11.5149 18.2147 11.8653 18.565C12.2158 18.9156 12.7843 18.9156 13.1348 18.565L19.7 11.9998L13.1348 5.43459Z","fill":"currentColor"}));
}

ArrowRebrandInline.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = ArrowRebrandInline;

ArrowRebrandInline.default = ArrowRebrandInline;
